// extracted by mini-css-extract-plugin
export default {"settingsContainer":"style_settingsContainer__CKFwd","logo":"style_logo__i+cyT"};